<template>
  <div class="marketing-automation-form-steps-item"
       :class="{ 'marketing-automation-form-steps-item_selected' : isSelected, 'marketing-automation-form-steps-item_timer' : isTimerType}">

    <div v-if="!isEntryType && isSelected"
         class="close"
         @click="emitDelete">&times;</div>

    <p class="marketing-automation-form-steps-item-name"
       @click="openPanelIfTimer">
      <i :class="`mdi mdi-${icon} pointer`"></i>
      {{ name }}
    </p>

    <button v-if="!isTimerType"
            class="marketing-automation-form-steps-item-action btn btn-round btn-primary"
            :class="{'marketing-automation-form-steps-item-action_active' : hasItem}"
            @click="openPanel">{{ entryActionText }}</button>

    <marketing-automation-form-panel :step="item"
                                     :type="type"
                                     :showing="showingPanel"
                                     :automationId="automationId"
                                     default
                                     @submit="emitNewStep"
                                     @hide="hidePanel" />
  </div>
</template>

<script>
import MarketingAutomationFormPanel from "@components/modules/marketing/automation/form/steps/panel/MarketingAutomationFormPanel";
import EventBus from "@packages/event-bus/index";

export default {
  components: {
    MarketingAutomationFormPanel,
  },

  props: {
    type: {
      type: String,
      required: true,
    },
    item: {
      type: Object,
      required: false,
    },
    automationId: {
      type: String,
    },
  },

  watch: {
    item: {
      deep: true,
      handler(newItem) {
        if (newItem.stepType === "CHANNEL") {
          this.setInitialData();
        }
      },
    },
  },

  created() {
    if (this.item && this.item.id) {
      this.setInitialData();
    }

    EventBus.$on("AUTOMATION_OPEN_PANEL", this.hideOpenedPanel);
  },

  beforeDestroy() {
    EventBus.$off("AUTOMATION_OPEN_PANEL", this.hideOpenedPanel);
  },

  computed: {
    icon() {
      return {
        ["SMS"]: "message-text-outline",
        ["EMAIL"]: "email-outline",
        ["TIMER"]: "clock-outline",
      }[this.type];
    },
    name() {
      return this.isEntryType
        ? this.$t("message.automation.message.flowInput")
        : this.isEmailType
        ? this.$t("message.automation.message.sendEmail")
        : this.isTimerType
        ? this.timerTypeName
        : this.isWhatsappType
        ? this.$t("message.automation.message.sendWhatsapp")
        : this.$t("message.automation.message.sendSms");
    },
    timerTypeName() {
      let finalName = this.$t("message.automation.message.wait");

      if (this.item.properties.days) {
        const daysName = `${this.item.properties.days} ${
          this.item.properties.days === 1
            ? this.$t("message.automation.message.day")
            : this.$t("message.automation.message.days")
        }`;

        finalName = finalName.concat(daysName);
      }

      const hourName = this.item.properties.hours
        ? ` ${this.item.properties.hours} ${
            this.item.properties.hours === 1
              ? this.$t("message.automation.message.hour")
              : this.$t("message.automation.message.hours")
          } `
        : "";

      if (hourName) {
        finalName = finalName.concat(hourName);
      }

      const minutesName = this.item.properties.minutes
        ? ` ${this.item.properties.minutes} ${
            this.item.properties.minutes === 1
              ? this.$t("message.automation.message.minute")
              : this.$t("message.automation.message.minutes")
          }`
        : "";

      if (minutesName) {
        finalName = finalName.concat(minutesName);
      }

      const scheduledHourName = this.item.properties.scheduledHour
        ? ` ${this.$t("message.automation.message.andSendAt")} ${
            this.item.properties.scheduledHour
          }`
        : ``;

      if (scheduledHourName) {
        finalName = finalName.concat(scheduledHourName);
      }

      return finalName;
    },
    isWhatsappType() {
      return this.type === "WHATSAPP";
    },
    isEmailType() {
      return this.type === "EMAIL";
    },
    isEntryType() {
      return this.type === "ENTRY";
    },
    isSmsType() {
      return this.type === "SMS";
    },
    isTimerType() {
      return this.type === "TIMER";
    },
    entryActionText() {
      return this.hasItem
        ? this.stepTypeOptions[this.item.stepType]
        : this.isEmailType
        ? this.$t("message.automation.message.setEmail")
        : this.isSmsType
        ? this.$t("message.automation.message.setSms")
        : this.isWhatsappType
        ? this.$t("message.automation.message.setWhatsapp")
        : this.$t("message.automation.message.setCriteria");
    },
    hasItem() {
      return !!this.item && !!this.item.id;
    },
    stepTypeOptions() {
      const properties = this.item.properties;

      return {
        ["START_BY_ACCESS"]: this.$t("message.automation.message.accessMade"),
        ["START_BY_PERIOD_WITHOUT_ACCESS"]: this.$t(
          "message.automation.message.periodWithoutAccess"
        ),
        ["START_BY_ACCESS_COUNT"]: this.$t(
          "message.automation.message.numberOfAccesses"
        ),
        ["START_BY_BIRTHDATE"]: `${this.$t(
          "message.automation.message.birthdayIn"
        )} ${properties.daysBeforeBirthdate} ${this.$t(
          "message.automation.message.days"
        )}`,
        ["START_BY_CAMPAIGN"]: this.$t("message.automation.message.campaign"),
        ["START_BY_EXTERNAL_DATABASE"]: "Base de dados externa",
        ["CHANNEL"]: this.getChannelTitle(),
      };
    },
  },

  data() {
    return {
      showingPanel: false,
      isSelected: false,
      email: undefined,
      sms: undefined,
      whatsapp: undefined,
      id: +new Date(),
    };
  },

  methods: {
    getChannelTitle() {
      if (this.isEmailType && this.email) {
        return this.email.title;
      }

      if (this.isSmsType && this.sms) {
        return this.sms.title;
      }

      if (this.isWhatsappType && this.whatsapp) {
        return this.whatsapp.title;
      }

      return this.$t("message.marketingGenerics.message.message");
    },
    hideOpenedPanel(id) {
      if (this.id !== id) {
        this.isSelected = false;
        this.showingPanel = false;
      }
    },
    async setInitialData() {
      if (this.type === "EMAIL") {
        this.email = await this.$api.marketing.email.message.get({
          emailId: this.item.properties.messageId,
        });
      } else if (this.type === "SMS") {
        this.sms = await this.$api.marketing.sms.message.get({
          smsId: this.item.properties.messageId,
        });
      } else if (this.type === "WHATSAPP") {
        this.whatsapp = await this.$api.marketing.whatsapp.message.get({
          messageId: this.item.properties.messageId,
        });
      }
    },
    openPanel() {
      EventBus.$emit("AUTOMATION_OPEN_PANEL", this.id);

      this.showingPanel = true;
      this.isSelected = true;
    },
    emitNewStep(newStep) {
      this.$emit("submit", newStep);
    },
    openPanelIfTimer() {
      if (this.isTimerType) {
        this.openPanel();
      }
    },
    hidePanel() {
      this.isSelected = false;
      this.showingPanel = false;
    },
    emitDelete() {
      this.$emit("delete", this.item.id);
    },
  },
};
</script>

<style lang="scss" scoped>
@import "~@variables";

.marketing-automation-form-steps-item {
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 15px 10px;
  min-width: 250px;
  border: 1px solid #d6d6d6;
  border-radius: 8px;

  .marketing-automation-form-steps-item-name {
    display: flex;
    align-items: center;
    margin: 0;
    margin-bottom: 10px;
    font-weight: 600;
    color: $grey-4;
    user-select: none;

    i {
      display: flex;
      align-items: center;
      margin-right: 5px;
    }
  }

  .marketing-automation-form-steps-item-action {
    padding-top: 5px;
    padding-bottom: 5px;
    font-size: 13px;

    &.marketing-automation-form-steps-item-action_active {
      background: $primary;
    }
  }

  &.marketing-automation-form-steps-item_selected {
    border-color: $primary;
  }

  &.marketing-automation-form-steps-item_timer {
    .marketing-automation-form-steps-item-name {
      margin-bottom: 0;
      cursor: pointer;
    }
  }

  .close {
    background: white;
    cursor: pointer;
    position: absolute;
    display: flex;
    align-items: center;
    justify-content: center;
    top: -12px;
    right: -12px;
    height: 30px;
    width: 30px;
    font-size: 22px;
    z-index: 1;
    border-radius: 50%;
  }
}
</style>
